/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_Load_From_PowerInputs */

const en_ui_more_stats_load_from_power = /** @type {(inputs: Ui_More_Stats_Load_From_PowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From power – compares best across sessions`)
};

const de_ui_more_stats_load_from_power = /** @type {(inputs: Ui_More_Stats_Load_From_PowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus Leistung – am besten vergleichbar`)
};

/**
* | output |
* | --- |
* | "From power – compares best across sessions" |
*
* @param {Ui_More_Stats_Load_From_PowerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_load_from_power = /** @type {((inputs?: Ui_More_Stats_Load_From_PowerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_Load_From_PowerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_load_from_power(inputs)
	return de_ui_more_stats_load_from_power(inputs)
});